module.exports = __webpack_public_path__ + "pt.340d3599145c63301d4a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pt.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pt.svg
// module chunks = styles